export enum Modules {
    _UkgBankingConnections_ = 1,
    _AppointmentWidget_ = 2,
    _WaitSmarter_ = 3,
    _Kiosk_=4,
    _RemoteCheckIn_=5,
    _UkgAppointments_=6,
    _BankingEventsWidget_=7,
    _RecruitingEventsWidget_=8
  }
